import { ComponentType } from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';

type RenderEntry = {
	element: ComponentType,
	container: Element,
}

export default [
	{
		element: Header,
		container: document.getElementById('react-header')
	},
	{
		element: Footer,
		container: document.getElementById('react-footer')
	},
] as RenderEntry[];
